import React from 'react'
import { Button, Col, Row } from 'reactstrap'

const AboutOurMission = () => {
  return (
    <div id='website-responsive'>
    <div className='left-padding6rem1 right-padding6rem1 py-md5 '>
        <Row className='reverse-section pt-md4'>
            <Col md='12' lg='6' className='ps0 m-en  pt-md-4'>
                <div className='py-4'>
                    <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                        OUR MISSION
                    </div>
                    <hr className='hr-style my-md-1' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>

                    <div className='pt-1'>
                        <text className='fs-ss-20 text-montserrat fw-600 text-ss-black' style={{ fontStyle:'italic'}}>
                            United Lab Care
                        </text>
                    </div>

                    <div className='py-4 pe-lg-5'>
                        <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        Our Mission at United Lab Care is to offer innovative, exceptional, and quick lab services in Chicago. Moreover, our testing services help industries & organizations of all sizes achieve predictable, improved testing quality levels, fast turnaround time & cost associated with testing integrity requirements.
                        </div>
                    </div>
                </div>
            </Col>

            <Col md='12' lg='5' className='flex-center'>
                <div className='flex-center10'>
                    <img className='imgw18' src='about-us/About-Us-img1-v1.webp' alt='Covid Services' height='auto' width='80%' />
                </div>
            </Col>
        </Row>
    </div>
</div>
  )
}

export default AboutOurMission